import React from "react";

// Shared keyboard behavior for the existing qualification and media dialogs.
export default function useAiAgentDialog(onClose, busy = false) {
  const dialogRef = React.useRef(null);
  const closeRef = React.useRef(onClose);
  closeRef.current = busy ? null : onClose;
  React.useEffect(() => {
    const previous = document.activeElement;
    const dialog = dialogRef.current;
    dialog?.querySelector("button, input, select, textarea, [tabindex='0']")?.focus();
    const onKey = event => {
      if (event.key === "Escape") { event.preventDefault(); event.stopPropagation(); closeRef.current?.(); }
      if (event.key !== "Tab") return;
      const items = [...dialog.querySelectorAll("button:not([disabled]), input:not([disabled]):not([type='hidden']), select:not([disabled]), textarea:not([disabled]), a[href], summary, [tabindex='0']")]
        .filter(item => { const closed = item.closest("details:not([open])"); return !closed || (item.tagName === "SUMMARY" && item.parentElement === closed); });
      const first = items[0], last = items[items.length - 1];
      if (!first) { event.preventDefault(); dialog.focus(); }
      else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    dialog?.addEventListener("keydown", onKey);
    return () => { dialog?.removeEventListener("keydown", onKey); previous?.focus?.(); };
  }, []);
  return dialogRef;
}
